export const CONSENT_TEXT_LINK_ID = "consentText";
export const CONSENT_AGREEMENT_LINK_ID = "consentAgreement";
export const FULL_NAME_LINK_ID = "fullName";
export const RECORDED_LINK_ID = "recorded";
export const SIGNATURE_LINK_ID = "signature";
